/**
 * @module VIDEO
 * @description handles the video autoplay, progression and looping based on video containers in the html code.
 */
;var VIDEO=(function(my){
  var videos = {};
  var timeoutID = null;

  const intersectionObserver = new IntersectionObserver(function(entries) {
    entries.forEach(entry=>{
      video = entry.target;
      if (entry.intersectionRatio<1) {
        video.pause();
      } else {
        if (Math.abs(video.currentTime-video.duration)<1) {
          video.currentTime=0;
        }
        video.play();
      }
    })
  }, {rootMargin: "200px", threshold: 1});

  /**
   * @method normalizeBoolean
   * @param {string} value the `string` value to be converted to `boolean` value
   * @description convert a DOM attribute value `'true'`/`'false'` to a `boolean` T/F value. 
   * If lowercase of input string is 'true' then `true` is retured else `false` is returned
   * @returns {boolean} `boolean` `true`/`false` value based on input.
   * @private
   */
  var normalizeBoolean = function(value) {
    if (value == null || (value && typeof value === 'string' && value.toLowerCase() !== 'true')) {
      return false;
    }
    return true;
  };

  /**
   * @method init
   * @description initialze the video module: 
   * 1. create a Vimeo video object based on .video-container node in the DOM
   * 2. initialze it based on its data attributes and other defaults
   * 3. auto assign DOM IDs
   * 4. store created Vimeo video player objects 
   * 5. register listeners for updating state for currently playing video and progression to next video
   * @public
   */
  my.init = function(){
    if (qsa(".video-container").length == 0) {
      return;
    }
    // Create Vimeo player objects for each video on the page
    const vimeoVideos = qsa('.video-container.vimeo-video-container');
    if (vimeoVideos.length > 0) {
      vimeoVideos.forEach((videoContainer, index) => {
        let options = {
          url: videoContainer.getAttribute('data-video-url'),
          loop: normalizeBoolean(videoContainer.getAttribute('data-video-loop-status')),
          autoplay: normalizeBoolean(videoContainer.getAttribute('data-video-autoplay-status')),
          width: 1920,
          maxwidth: '100%',
          title: false,
          muted: true,
          controls: false,
          byline: false,
          // quality: '1080p',
          autopause: false,
          portrait: false,
          dnt: isDoNotTrackEnabled(),
  
        };
        let video=null;
        try {
          video = new Vimeo.Player(videoContainer, options);
        } catch (err) {
          console.log(err);
          VIDEO.resetToImageBanner();
        }
        video.videoContainerID = videoContainer.id;
        video.isCurrent = false;
        videos[videoContainer.id] = video;
      });
  
      videos['mainvideo'].on('play', function(){
        console.log('mainvideo started playing');
        setCurrentVideo(this);
      });
      videos['mainvideo'].addCuePoint(172);
      videos['mainvideo'].on('cuepoint', switchToLoopingVideo);
      
      qs('#loopedvideo').addClass('preloading');
      videos['loopedvideo'].on('play', preloaded);
      setTimeout(function(){
        videos['loopedvideo'].play();
      }, 5000);
  
    }

    qsa('body.monitoring .mp4-video-container video').forEach(video=>intersectionObserver.observe(video));
  }
  /**
   * @method setCurrentVideo
   * @description Sets a specified player as the current video, bringing it to top and marking the video container 
   * as active
   * @param {object} vid 
   * @private
   */
  var setCurrentVideo=function(vid) {
    qs(`#${vid.videoContainerID}`).addClass('current');
    Object.values(videos).forEach(v=>v.isCurrent=false);
    vid.isCurrent=true;
    if (vid == videos['mainvideo']){
      qs('.banner').addClass('playing-video');
      qs('.video-banner').addClass('current');
    } else {
      setTimeout(()=>qs('#mainvideo').removeClass('current'), 500);
    }
  }
  
  /**
   * @method preloaded
   * @description Listener called when the second looping video has gotten loaded. Pauses the video and removes
   * itself as a listener.
   * @private
   */
  var preloaded=function(){
    console.log('loopedvideo preloaded1');
    setTimeout(function(){
      console.log('loopedvideo preloaded2');
      videos['loopedvideo'].pause();
      videos['loopedvideo'].setCurrentTime(0);
      qs('#loopedvideo').removeClass('preloading');
      videos['loopedvideo'].off('play', preloaded);
      videos['loopedvideo'].on('play', function(){
        console.log('loopedvideo started playing');
        setCurrentVideo(this);
      });
    },1000);
  }

  /**
   * @method switchToLoopingVideo
   * @description listener called when the cuepoint on the first video is hit. Starts playing the looped video
   * @param {object} d vimeo parameters for console logging
   * @private
   */
  var switchToLoopingVideo=function(d){
    console.log('switching to loopedvideo', d.duration, d.seconds);
    videos['loopedvideo'].play();
  }

  /**
   * @method getVideo
   * @description useful function for debugging. Can be used to get a player object from the console.
   * @param {string} id [optional] string id "mainvideo" or "loopedvideo". Returns array of player objects if no parameters are passed.
   */
  my.getVideo=function(id){
    if (!id) return Object.values(videos);
    return videos[id];
  };
  return my;
}(VIDEO || {}));